import {WidgetAccordion} from "../../organisms/widget--accordion";

export function ParagraphAccordion ({paragraph, ...props}) {
  if (!paragraph?.field_accordion_items?.length) return <></>

  return (
    <div className="paragraph--accordion pb-6">
      {paragraph.field_accordion_items.map((item, idx) => (
        <WidgetAccordion key={`${paragraph.id}-${idx}`} title={item.key} content={item.processed}/>
      ))}
    </div>
  )
}